import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import UnifiedWhiteboard from "@/pages/UnifiedWhiteboard";

/* Sidebar "Interactive Board" entry — if the teacher has a class LIVE right
 * now, the board must open INSIDE that class (collab, remote access and
 * student broadcast only work there). Otherwise it's a solo scratch board. */
export default function BoardLauncher() {
  const [checked, setChecked] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/classes");
        const live = (data.classes || [])
          .filter((c) => c.status === "live")
          .sort((a, b) => (b.start_time || "").localeCompare(a.start_time || ""))[0];
        if (live) {
          toast.info(`Opening the board inside your live class "${live.title}" — remote access & student sync enabled`);
          nav(`/live/${live.id}?board=1`, { replace: true });
          return;
        }
      } catch { /* fall through to solo board */ }
      setChecked(true);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!checked) return <div className="min-h-[50vh] flex items-center justify-center text-neutral-500 text-sm">Checking for a live class…</div>;
  return <UnifiedWhiteboard />;
}
